module.exports = __webpack_public_path__ + "img/s3.c4367f20.png";